import { CampaignType } from 'types/domain'
import { Storage } from 'utils'
import { useContext } from 'react'
import ApplicationContext from 'components/business/Layouts/ApplicationLayout/ApplicationContext'

export enum LayoutType {
  LIST = 'list',
  GRID = 'grid',
}

export default function useCampaignLayoutCache() {
  const { me, application } = useContext(ApplicationContext)

  const getDefaultLayout = (campaignType: CampaignType) => {
    const res = Storage.getItem(getKey()) ?? {}
    return res[campaignType] ?? LayoutType.LIST
  }

  const setDefaultLayout = (campaignType: CampaignType, layout: LayoutType | null) => {
    const key = getKey()
    const old = Storage.getItem(key) ?? {}
    Storage.setItem(key, { ...old, [campaignType]: layout })
  }

  const getKey = () => {
    return `hx_user_${me?.id}_application_${application?.id}_layouts`
  }

  return {
    getDefaultLayout,
    setDefaultLayout,
  }
}
